import React from 'react';
import { Typography, InfoIcon } from '@ag1/ui';
import CustomPortableText from 'shared/studio/PortableText/PortableText';
import { AlternateFlavor, AlternateFlavorConfig } from '@portal/processes/ShopV2/ShopV2.types';
import { vars } from '@ag1/ui/theme';
import { errorMessage, flavorMessage } from './FlavorSelection.css';

type Flavor = AlternateFlavor | AlternateFlavorConfig;

interface FlavorMessageProps {
  flavorVariants: Flavor[];
  activeVariantId: string;
  outOfStockText: string;
}

export const FlavorMessage: React.FC<FlavorMessageProps> = ({
  flavorVariants,
  activeVariantId,
  outOfStockText
}) => {
  return (
    <>
      {flavorVariants.map((flavor) => {
        if (flavor.id !== activeVariantId) return null;

        const isOutOfStock = flavor.outOfStock;
        const message = flavor.flavorMessage;

        if (isOutOfStock && message) {
          return (
            <Typography
              key={flavor.id}
              color="status-error"
              variant="body"
              size="2"
              noPadding
              className={errorMessage}>
              <InfoIcon color={vars.colors.text.error} />
              {outOfStockText || 'This flavor is temporarily out of stock'}
            </Typography>
          );
        }

        if (message) {
          return (
            <div className={flavorMessage} key={flavor.id}>
              <CustomPortableText value={message} />
            </div>
          );
        }

        return null;
      })}
    </>
  );
};
